/* eslint-disable react/prop-types*/
import { Component } from '@verndale/core';
import anime from 'animejs';

class BookNow extends Component {
  constructor(el, disableScroll = true, manualHeightInit = false) {
    super(el);
    this.disableScroll = disableScroll;
    this.manualheightInit = manualHeightInit;
  }
  setupDefaults() {
    this.expanded = false;
    this.focusedLink = 0;
    this.dom = {
      body: document.querySelector('body'),
      trigger: this.el.querySelector('.book-now__trigger'),
      popup: this.el.querySelector('.book-now__popup'),
      links: [...this.el.querySelectorAll('.book-now__link')],
      overlay: this.el.querySelector('.book-now__overlay')
    };
    this.setupExternalIcon();
    if (!this.manualheightInit) this.popupHeight = this.dom.popup.offsetHeight;
  }

  addListeners() {
    this.dom.trigger.addEventListener('click', event =>
      this.toggleDropdown(event)
    );
    // Handle trigger keyboard events
    this.dom.trigger.addEventListener('keydown', event =>
      this.handleTriggerKeyEvents(event)
    );
    // Handle popup keyboard events
    this.dom.popup.addEventListener('keydown', event =>
      this.handlePopupKeyEvents(event)
    );
    // Handle click outside
    this.dom.overlay.addEventListener('click', event => {
      event.stopPropagation();
      this.toggleDropdown(event);
    });
    window.addEventListener('click', e => {
      if (this.expanded) this.toggleDropdown(e);
    });
  }

  changeScroll() {
    if (this.expanded) {
      const scrollY = window.scrollY;
      this.dom.body.style.position = 'fixed';
      this.dom.body.style.top = `-${scrollY}px`;
      this.dom.body.style.overflowY = 'scroll';
    } else {
      const scrollY = document.body.style.top;
      this.dom.body.style.position = null;
      this.dom.body.style.top = null;
      this.dom.body.style.overflowY = null;
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
  }

  recalculatePopupHeight() {
    this.popupHeight = this.dom.popup.offsetHeight;
  }

  toggleDropdown(e) {
    e?.stopPropagation();
    if (!this.popupHeight) return;
    const isTriggeredByKeyboard = e?.detail === 0;
    // Update expanded state
    this.expanded = !this.expanded;
    //Toggle scroll
    if (this.disableScroll) this.changeScroll();
    // Show/hide white overlay
    this.dom.overlay.classList.toggle('active');
    // Update trigger aria-expanded attribute
    this.dom.trigger.setAttribute('aria-expanded', this.expanded);
    // Show/hide popup
    if (this.expanded) this.dom.popup.classList.add('active');
    anime({
      targets: this.dom.popup,
      easing: 'easeInOutQuad',
      height: [0, this.popupHeight], // -> '250px'
      duration: 400,
      direction: this.expanded ? 'normal' : 'reverse',
      complete: () =>
        !this.expanded && this.dom.popup.classList.remove('active')
    });
    //Focus first link if exists on open and event was trigger by keyboard
    if (
      this.expanded &&
      isTriggeredByKeyboard &&
      this.dom.links[this.focusedLink]
    ) {
      this.dom.links[this.focusedLink].focus();
    }
    // Reset focusedLink on close
    if (!this.expanded) this.focusedLink = 0;
  }

  handleTriggerKeyEvents(e) {
    // Open/close popup
    if (e.key === 'ArrowDown' || (this.expanded && e.key === 'Escape')) {
      this.toggleDropdown(e);
    }
  }

  handlePopupKeyEvents(e) {
    // Close popup
    if (e.key === 'Escape') {
      this.toggleDropdown();
      // Focus trigger
      return this.dom.trigger.focus();
    }
    // Navigate links using arrows
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      const delta = {
        ArrowUp: -1,
        ArrowDown: 1
      };
      const linksLength = this.dom.links.length;
      const linkToFocusIndex = this.focusedLink + delta[e.key];
      // Circle back to last link
      if (linkToFocusIndex < 0) {
        this.dom.links[linksLength - 1].focus();
        return (this.focusedLink = linksLength - 1);
      }
      // Circle back to first link
      if (linkToFocusIndex > linksLength - 1) {
        this.dom.links[0].focus();
        return (this.focusedLink = 0);
      }
      // Natural navigation
      this.dom.links[linkToFocusIndex].focus();
      return (this.focusedLink = linkToFocusIndex);
    }
  }

  setupExternalIcon() {
    this.dom.links.forEach(link => {
      const href = link.getAttribute('href');
      if (!href.includes('http') || href.includes(window.location.host)) {
        link.classList.remove('external');
      }
    });
  }
}

export default BookNow;
